import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kilometers'
})
export class KilometerPipe implements PipeTransform {
  // Currently the value will be in miles
  transform(value: number, decimals?: number, noSuffix?: boolean, convertingValueUnit?: string): string {
    let _value = Number(value);
    let _decimal = decimals != null ? decimals : 2; // Default is 2 decimal places
    let _suffix = noSuffix

    let _uom;
    if (convertingValueUnit) {
      _uom = convertingValueUnit;
    } else {
      _uom = 'MLS';
    }
    if (_uom === 'MLS') {
      return (_value * 1.609).toFixed(_decimal) + (noSuffix ? '' : 'kms');
    } else if (_uom === 'MTRS') {
      return (_value / 1000).toFixed(_decimal) + (noSuffix ? '' : 'kms');
    }
  }

}



@Pipe({
  name: 'kilometers'
})
export class VehicleHelpKilometerPipe implements PipeTransform {
  // Currently the value will be in miles
  transform(value: number, decimals?: number, noSuffix?: boolean, convertingValueUnit?: string): string {
    let _value = Number(value);
    let _decimal = decimals != null ? decimals : 2; // Default is 2 decimal places
    let _suffix = noSuffix

    let _uom;
    if (convertingValueUnit) {
      _uom = convertingValueUnit;
    } else {
      _uom = 'MLS';
    }
    if (_uom === 'MLS') {
      return (_value * 1.609).toFixed(_decimal) + (noSuffix ? '' : 'kms');
    } else if (_uom === 'MTRS') {
      return (_value / 1000).toFixed(_decimal) + (noSuffix ? '' : 'kms');
    }
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/distance/kilometer.pipe.ts